// Who shared a recipe with you, at the foot of the recipe page. The owner's
// side is the share sheet (RecipeShareSheet.tsx, slice 8a).
import { useState, useEffect } from "react";
import { FONT_SIZE } from "../lib/constants";
import { getRecipeSharedBy, loadHouseholdMembers } from "../lib/db";

// Rendered instead of the share sheet for a recipe someone else shared with
// the current user -- reveals only their own "shared by" fact (see
// get_recipe_shared_by's comment), never anyone else's.
export function SharedByNotice({ recipe, colors }) {
  const { soft } = colors;
  const [sharedBy, setSharedBy] = useState(null);
  // A recipe can also be visible with no share row at all, because its owner
  // is in the viewer's household and has switched on "let my household see my
  // recipes" (0040). The members list is how we name them.
  const [householdOwner, setHouseholdOwner] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getRecipeSharedBy(recipe.id)
      .then((row) => {
        if (!cancelled) setSharedBy(row);
      })
      .catch(() => {});
    loadHouseholdMembers()
      .then((rows) => {
        if (!cancelled) setHouseholdOwner(rows.find((m) => !m.is_me && m.user_id === recipe.ownerUserId) || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [recipe.id, recipe.ownerUserId]);
  // A quiet line at the foot of the recipe page, not a box (board 29).
  const boxStyle = { fontSize: FONT_SIZE.sm, color: soft, margin: 0 };
  // A url_import-origin relationship (both households independently
  // imported the same URL) shows nothing at all here -- not a generic
  // placeholder, nothing -- since neither household chose it and it isn't
  // relevant to either party.
  if (sharedBy && sharedBy.origin !== "url_import") {
    return (
      <div className="mp-sans" style={boxStyle}>
        Shared with you by <strong>{sharedBy.email}</strong>
      </div>
    );
  }
  if (householdOwner) {
    return (
      <div className="mp-sans" style={boxStyle}>
        From <strong>{householdOwner.email}</strong> in your household
        <span style={{ color: soft }}> — view only</span>
      </div>
    );
  }
  return null;
}
